import { Grid, Link } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import PropTypes from 'prop-types';
import React from 'react';
import parse from 'html-react-parser';
import HlxButton from '../../commonComponents/button/button';
import { StyledApprovelDetail } from '../approvalDetail/approvalDetail.style';
import { StyledTicketDetail } from '../ticketDetail/ticketDetail.style';
import HyperLink from "../../commonComponents/hyperLink/hyperLink";
import { NOT_APPLICABLE, YES, APPROVALS_ORIGINALSTATE } from '../../../constants/originalState';
import { TICKET_REQUEST_TYPE } from '../ticketDetail/ticketDetail';
import { TruncatedText } from 'component/MarketPlace/Typography/Typography.style';
import { StyledTooltip } from 'component/cardComponent/pcCard/pcCard.style';
import Typography from 'component/MarketPlace/Typography';
import DefaultUptimeTheme from 'component/theme/defaultTheme';
import { useTheme } from 'styled-components';
import { capitalizeFirstLetter } from 'utils/functions';
import { DISPATCH_MODE } from '../constant';


export interface IApprovalDetailProps {
  isLoading?: boolean,
  infoApprovalDetail: any,
  requestedDate: any,
  onApprovalClick: () => void,
  onRejectClick: () => void,
  KBPcCost: any,
  locale: any,
  ticketCatalog: any,
  vdaticketCatalog: string,
  isCheckBtnApprove?: boolean,
  isCheckBtnReject?: boolean,
  snowLinkTicket?: any
};


const ApprovalDetail = (props: IApprovalDetailProps) => {

  const { isLoading, infoApprovalDetail, requestedDate, onApprovalClick, onRejectClick, KBPcCost, locale, ticketCatalog, isCheckBtnApprove, isCheckBtnReject, vdaticketCatalog, snowLinkTicket } = props;
  const { requestItem, approver, originalState } = infoApprovalDetail;
  const variableInfo = requestItem?.variables;
  const visibleVariablesInfo = requestItem?.visible_variables;
  const json_storage = requestItem?.variables?.json_storage;
  let subTitleText : any = null;
  let commonStatusText : any = null;
  if(locale){
    const { subTitle, commonStatus } = locale;
    subTitleText = subTitle;
    commonStatusText = commonStatus;
  }
  const isPCLifecycle = ticketCatalog === requestItem?.catalog?.id;
  const isVDASoftware = vdaticketCatalog === requestItem?.catalog?.id;
  const isNewVda = [TICKET_REQUEST_TYPE.NEW_VDA].includes(variableInfo?.json_storage?.request_type);
  const isAppRequest = [TICKET_REQUEST_TYPE.APP_REQUEST].includes(variableInfo?.json_storage?.request_type);
  const isVA = [TICKET_REQUEST_TYPE.VA_REQUEST].includes(variableInfo?.json_storage?.request_type);
  const isNonPclifecycle = !isPCLifecycle;
  const requestorname = isNonPclifecycle ? requestItem?.openBy : (json_storage?.requestor_name || variableInfo?.opened_by);
  const requestorEmail = isNonPclifecycle ? requestItem?.openByEmail : json_storage?.requestor_email;
  const recipientName = isNonPclifecycle ? requestItem?.requestFor : (json_storage?.recipient_name || variableInfo?.recipient_name);
  const recipientEmail = isNonPclifecycle ? requestItem?.email : (json_storage?.user_email || variableInfo?.recipient_email);
  const getStatusText = (status: string) => commonStatusText?.[status?.toUpperCase() || ''] || status?.toUpperCase();
  const stateValue = getStatusText(infoApprovalDetail?.state) || NOT_APPLICABLE;
  const stageValue = getStatusText(variableInfo?.stage?.display_value) || getStatusText(infoApprovalDetail?.originalState) || NOT_APPLICABLE;
  const theme = useTheme() as typeof DefaultUptimeTheme;

  const configTracking = (string: any) => {
    if (!!string) {
      if (string.indexOf("http") > -1) {
        return (
          <a href={string} target="blank" className="link-tracking">
            {isPCLifecycle || isVDASoftware ? locale?.clickToTrack : locale?.link}
          </a>
        );
      }
      return `${string}`;
    }
    return NOT_APPLICABLE;
  };

  const renderInfoTicket = (visible_variables: any, variables: any) => {
    return visible_variables?.map((field: any) => (
      <Grid item xs={6} className="pr-20">
        <p className="ttl-col-desc">{capitalizeFirstLetter(field?.label)}</p>
        <p className="value-info" id={`lbl-approvaldetail-${field?.id}`}>{parse(variables?.[field?.name])}</p>
      </Grid>
    ));
  };

  return (
    <StyledTicketDetail>
      <StyledApprovelDetail>
        {isLoading ?
          <CircularProgress className="isLoadingTicketDetail" id="img-approvaldetail-loading" />
          :
          <>
            <StyledTooltip title={requestItem?.shortDescription} placement="bottom-start">
              <TruncatedText
                maxlines={1}
                variant="h4"
                className="title-ticket"
                sx={{
                  fontSize: '24px',
                  fontWeight: '700',
                  color: 'text.primary'
                }}
                id="lbl-approvaldetail-short_description"
              >
                {requestItem?.shortDescription}
              </TruncatedText>
            </StyledTooltip>
            <Grid container>
              <Grid item xs={6} className="pr-20">
                <p>
                  <span className="ttl-bold">{subTitleText?.status}</span>
                  <span className={`value state ${infoApprovalDetail?.state}`} id="lbl-approvaldetail-state">{stateValue}</span>
                </p>
              </Grid>
              <Grid item xs={6}>
                <p>
                  <span className="ttl-bold">{subTitleText?.stage}</span>
                  <span className={`value state ${variableInfo?.stage?.value}`} id="lbl-approvaldetail-display_value">{stageValue}</span>
                </p>
              </Grid>
            </Grid>

            <Grid container>
              <Grid item xs={6} className="pr-20">
                <p>
                  <span className="ttl-bold">{subTitleText?.requested}</span>
                  <span className="value" id="lbl-approvaldetail-requesteddate">{requestedDate ? requestedDate : NOT_APPLICABLE}</span>
                </p>
              </Grid>
              <Grid item xs={6}>
                <p>
                  <span className="ttl-bold">{subTitleText?.requestNumber}</span>
                  {snowLinkTicket?.enabled ? (
                    <Link
                      onClick={() =>
                        window.open(
                          snowLinkTicket?.snowUrlRequest?.replace(
                            "{ticketId}",
                            requestItem.id
                          ),
                          "_blank"
                        )
                      }
                      sx={{
                        cursor: "pointer",
                        textDecoration: "none !important",
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          color: theme.uptimeColors.generalColors.button.hyperlink.enabled,
                          "&:hover": {
                            color: theme.uptimeColors.generalColors.button.hyperlink.hover,
                          },
                        }}
                        fontWeight={600}
                        id="lbl-approvaldetail-number"
                      >
                        {requestItem?.number
                          ? requestItem?.number
                          : NOT_APPLICABLE}
                      </Typography>
                    </Link>
                  ) : (
                    <span className="value" id="lbl-approvaldetail-number">
                      {requestItem?.number
                        ? requestItem?.number
                        : NOT_APPLICABLE}
                    </span>
                  )}
                </p>
              </Grid>
            </Grid>

            {!['CLOSED'].includes(infoApprovalDetail?.state?.toUpperCase()) &&
              <Grid container className='group-btn'>
                { isCheckBtnApprove && <HlxButton
                  label={subTitleText?.btnApproval}
                  onClick={onApprovalClick}
                  id="btn-approvaldetail-approval"
                />}
                { isCheckBtnReject && <HlxButton
                  label={subTitleText?.btnReject}
                  onClick={onRejectClick}
                  id="btn-approvaldetail-reject"
                />}
              </Grid>
            }

            <div className="desc-ticket">
              <Grid container>
                <Grid item xs={6} className="pr-20">
                  <p className="ttl-col-desc">{locale?.requestorName}</p>
                  <p className="value-info" id="lbl-approvaldetail-requestor_name">{requestorname || NOT_APPLICABLE}</p>
                </Grid>
                <Grid item xs={6}>
                  <p className="ttl-col-desc">{locale?.requestorEmail}</p>
                  <p className="value-info" id="lbl-approvaldetail-requestor_email">{requestorEmail || NOT_APPLICABLE}</p>
                </Grid>
              </Grid>

              <Grid container>
                <Grid item xs={6} className="pr-20">
                  <p className="ttl-col-desc">{locale?.recipientName}</p>
                  <p className="value-info" id="lbl-approvaldetail-recipient_name">{recipientName || NOT_APPLICABLE}</p>
                </Grid>
                <Grid item xs={6}>
                  <p className="ttl-col-desc">{locale?.recipientEmail}</p>
                  <p className="value-info" id="lbl-approvaldetail-user_email">{recipientEmail || NOT_APPLICABLE}</p>
                </Grid>
              </Grid>

              {!isAppRequest && (
                <>
                  <Grid container>
                    {json_storage?.employee_type && (
                      <Grid item xs={6} className="pr-20">
                      <p className="ttl-col-desc">{locale?.workerType}</p>
                      <p className="value-info" id="lbl-approvaldetail-employee_type">{json_storage?.employee_type ? json_storage?.employee_type : NOT_APPLICABLE}</p>
                    </Grid>
                    )}
                    {!isAppRequest && !isNewVda && !isVA && (
                      <Grid item xs={6}>
                      <p className="ttl-col-desc">{locale?.reason_for_approval}</p>
                      <p className="value-info" id="lbl-approvaldetail-request_context">{!!json_storage?.request_context ? json_storage?.request_context : NOT_APPLICABLE}</p>
                    </Grid>
                    )}
                  </Grid>

                  <Grid container>
                    <Grid item xs={6} className="pr-20">
                      <p className="ttl-col-desc">{locale?.costCenter}</p>
                      <p className="value-info" id="lbl-approvaldetail-cost_center">{!!json_storage?.cost_center ? json_storage?.cost_center : NOT_APPLICABLE}</p>
                    </Grid>
                    {!isAppRequest && !isNewVda && !isVA && (
                      <Grid item xs={6}>
                      <p className="ttl-col-desc">{locale?.pc_exception_faq}</p>
                      <p className="value-info">
                        <HyperLink
                          label={locale?.clickHere}
                          onClick={() => window.open(`/knowledge/detail/${KBPcCost}`, '_blank')}
                          id="lnk-approvaldetail-click_here"
                          />
                      </p>
                      </Grid>
                    )} 
                  </Grid>
                </>
              )}
              {isNonPclifecycle ? (
                <Grid container>
                  {<Grid item xs={6} className="pr-20">
                    <p className="ttl-col-desc">{approver?.delegate ? locale?.managerInfo : locale?.approverInfo}</p>
                    <p className="value-info" id="lbl-approvaldetail-approver_email">{json_storage?.approver_email || approver?.email || NOT_APPLICABLE}</p>
                  </Grid>}
                  {infoApprovalDetail.state.toUpperCase() === "CLOSED" && infoApprovalDetail?.approver?.id !== infoApprovalDetail?.approvalBy?.id && <Grid item xs={12} className="pr-20">
                    <p className="ttl-col-desc">{locale?.delegatedApproverInfo}</p>
                    <p className="value-info" id="lbl-approvaldetail-delegated_to_email">{!!infoApprovalDetail?.approvalBy?.email ? infoApprovalDetail?.approvalBy?.email : NOT_APPLICABLE}</p>
                  </Grid>}
                  {(infoApprovalDetail?.approver?.delegate || infoApprovalDetail?.approver?.id !== infoApprovalDetail?.approvalBy?.id)
                    && infoApprovalDetail.state.toUpperCase() === "CLOSED" && (
                      <Grid item xs={6} className="pr-20">
                        <p className="ttl-col-desc">{infoApprovalDetail.originalState.toUpperCase() === APPROVALS_ORIGINALSTATE.APPROVED ? locale?.approvedBy : locale?.rejectedBy}</p>
                        <p className="value-info" id="lbl-approvaldetail-approval_by_email">{infoApprovalDetail?.approvalBy?.email ? infoApprovalDetail?.approvalBy?.email : NOT_APPLICABLE}</p>
                      </Grid>
                    )
                  }
                </Grid>
              ) : (
                <Grid container>
                  {<Grid item xs={6} className="pr-20">
                    <p className="ttl-col-desc">{json_storage?.delegated === YES ? locale?.managerInfo : locale?.approverInfo}</p>
                    <p className="value-info" id="lbl-approvaldetail-approver_email">{json_storage?.approver_email || approver?.email || NOT_APPLICABLE}</p>
                  </Grid>}
                  {json_storage?.delegated === YES && <Grid item xs={12} className="pr-20">
                    <p className="ttl-col-desc">{locale?.delegatedApproverInfo}</p>
                    <p className="value-info" id="lbl-approvaldetail-delegated_to_email">{!!json_storage?.delegated_to_email ? json_storage?.delegated_to_email : NOT_APPLICABLE}</p>
                  </Grid>}
                  {(infoApprovalDetail?.approver?.delegate || infoApprovalDetail?.approver?.id !== infoApprovalDetail?.approvalBy?.id)
                    && infoApprovalDetail.state.toUpperCase() === "CLOSED" && (
                      <Grid item xs={6} className="pr-20">
                        <p className="ttl-col-desc">{infoApprovalDetail.originalState.toUpperCase() === APPROVALS_ORIGINALSTATE.APPROVED ? locale?.approvedBy : locale?.rejectedBy}</p>
                        <p className="value-info" id="lbl-approvaldetail-approval_by_email">{infoApprovalDetail?.approvalBy?.email ? infoApprovalDetail?.approvalBy?.email : NOT_APPLICABLE}</p>
                      </Grid>
                    )
                  }
                </Grid>
              )
              }
              {originalState === 'Rejected' ?
                <Grid container>
                  {!isAppRequest && (
                    <Grid item xs={6}>
                      <p className="ttl-col-desc">{locale?.business_justification_comments}</p>
                      <p className="value-info" id="lbl-approvaldetail-business_justification">{parse(json_storage?.business_justification || NOT_APPLICABLE)}</p>
                    </Grid>
                  )}
                  <Grid item xs={6} className="pr-20">
                    <p className="ttl-col-desc">{locale?.rejectComment}</p>
                    <p className="value-info" id="lbl-approvaldetail-comments">{ approver.comments?.[0].comment }</p>
                  </Grid>
                </Grid>
                : (!isAppRequest && (
                  <Grid container>
                    <Grid item xs={12}>
                      <p className="ttl-col-desc">{locale?.business_justification_comments}</p>
                      <p className="value-info" id="lbl-approvaldetail-business_justification_comments">{parse(json_storage?.business_justification || NOT_APPLICABLE)}</p>
                    </Grid>
                  </Grid>
                ))
              }
              {!isAppRequest && !isNewVda && !isVA && !isNonPclifecycle && (
                <>
                  <Grid container>
                    <Grid item xs={12}>
                      <p className="ttl-col-desc">{locale?.requestedDevice}</p>
                      <p className="value-info" id="lbl-approvaldetail-new_asset_model">
                        <strong>{locale?.modelName}:</strong> {requestItem?.requestedModel?.name || variableInfo?.json_storage?.user_device_profile || variableInfo?.json_storage?.new_device_model_name || NOT_APPLICABLE}
                      </p>
                    </Grid>
                  </Grid>
                  <Grid container>
                    <Grid item xs={6} className="pr-20">
                      <p className="ttl-col-desc">{json_storage?.new_device_dispatch_mode === DISPATCH_MODE.PICKUP_FROM_DEPOT? locale?.pickUpAddress : locale?.shippingAddress}</p>
                      <p className="value-info value-replacement" id="lbl-approvaldetail-delivery_address">
                        {!!variableInfo?.delivery_address ? variableInfo?.delivery_address : NOT_APPLICABLE}
                      </p>
                    </Grid>
                    <Grid item xs={6}>
                      <p className="ttl-col-desc">{locale?.trackingInfo}</p>
                      <p className="value-info" id="lbl-approvaldetail-delivery_ref">
                        {configTracking(variableInfo?.delivery_ref)}
                      </p>
                    </Grid>
                  </Grid>
                </>
              )}
              {(isNewVda || isVA || isAppRequest) && json_storage?.app_name && 
                <Grid container>
                  <Grid item xs={6}>
                    <p className="ttl-col-desc">{locale?.requestedItem}</p>
                    <p className="value-info" id="lbl-newvirtualdevice-app_name">{json_storage?.app_name || NOT_APPLICABLE}</p>
                  </Grid>
                </Grid>
              }
              {json_storage?.starting_date &&
                <Grid container>
                  <Grid item xs={6}>
                    <p className="ttl-col-desc">{locale?.starting_date}</p>
                    <p className="value-info" id="lbl-approvaldetail-starting_date">{json_storage?.starting_date || NOT_APPLICABLE}</p>
                  </Grid>
                </Grid>
              }
              {json_storage?.personal_email &&
                <Grid container>
                  <Grid item xs={6}>
                    <p className="ttl-col-desc">{locale?.personal_email}</p>
                    <p className="value-info" id="lbl-approvaldetail-personal_email">{json_storage?.personal_email || NOT_APPLICABLE}</p>
                  </Grid>
                </Grid>
              }
              {visibleVariablesInfo?.length > 0 && (
                <Grid container>
                  {renderInfoTicket(visibleVariablesInfo, variableInfo)}
                </Grid>
              )}
            </div>
          </>
        }

      </StyledApprovelDetail>
    </StyledTicketDetail>
  );
};

ApprovalDetail.propTypes = {
  isLoading: PropTypes.bool,
  requestedDate: PropTypes.string,
  KBPcCost: PropTypes.string,
  infoApprovalDetail: PropTypes.object,
  onApprovalClick: PropTypes.func,
  onRejectClick: PropTypes.func,
  locale: PropTypes.object,
};

ApprovalDetail.defaultProps = {
  isLoading: false,
  requestedDate: '2 days ago',
  infoApprovalDetail:{
    "id": "3bd54d1b977859105026b1e3f153af65",
    "createdOn": "2022-07-25 06:06:50",
    "updatedOn": "2022-07-25 06:07:57",
    "state": "Closed",
    "originalState": "Approved",
    "requestItem": {
      "id": "f3d54d1b977859105026b1e3f153af33",
      "number": "RITM0011506",
      "state": "Open",
      "createDate": "2022-07-25 06:06:50",
      "updateDate": "2022-07-25 06:07:59",
      "shortDescription": "PC Order Request",
      "description": "",
      "priority": "4 - Low",
      "openBy": "Tuan Nguyen",
      "requestFor": "Tuan Nguyen",
      "email": "tuanvoanh.nguyen@dxc.com",
      "telephone": "",
      "location": "",
      "catalog": {
        "id": "7975f21cdbe6bc5018e16462ca96196a",
        "name": "PC Lifecycle"
      },
      "category": "",
      "subCategory": "",
      "quantity": 1,
      "requestNumber": "REQ0011502",
      "actions": {
        "canComment": true,
        "canUploadAttachment": true,
        "canCancel": false
      },
      "comments": {
        "totalItems": 1,
        "items": [
          {
            "comment": "Replacement no longer required",
            "createdBy": {
              "name": "Tuan Nguyen",
              "userId": ""
            },
            "createdOn": "2022-07-25 06:07:59",
            "userImage": ""
          }
        ]
      },
      "variables": {
        "request_type": "New Device",
        "request_for": "Tuan Nguyen",
        "delivery_address": "Tuan Nguyen, Home : +18888888888, chl, 4166 Clarence Court, 49730, Fayetteville, nb",
        "delivery_ref": null,
        "stage": {
          "value": "preparing_device",
          "display_value": "Preparing Device"
        },
        "asset": null,
        "asset_model": "",
        "asset_model_type": "undefined",
        "asset_language": "undefined",
        "state": "",
        "substate": "",
        "json_storage": {
          "user_name": "tuanvoanh.nguyen@dxc.com",
          "request_type": "new_device",
          "user_sys_id": "3793f73197030d105026b1e3f153af9b",
          "user_email": "tuanvoanh.nguyen@dxc.com",
          "user_address": "Tuan Nguyen, Home : +18888888888, chl, 4166 Clarence Court, 49730, Fayetteville, nb",
          "approval_required": "yes",
          "requestor_sys_id": "3793f73197030d105026b1e3f153af9b",
          "requestor_email": "tuanvoanh.nguyen@dxc.com",
          "employee_type": "",
          "recipient_name": "Tuan Nguyen",
          "new_model_sys_id": "5c596823dbe73450f5d33892399619a7",
          "stockroom_sys_id": "2e36ecd64780d11038403852e36d4357",
          "stockroom_assignment_group_sys_id": "fe25d087db2eb010bf85ce1c29961924",
          "request_context": "Additional device request",
          "approver_sys_id": "3793f73197030d105026b1e3f153af9b",
          "approver_email": "tuanvoanh.nguyen@dxc.com",
          "cost_center": "123456",
          "business_justification": "Job requires a higher performance PC",
          "requestor_first_name": "Tuan",
          "user_first_name": "Tuan",
          "approver_first_name": "Tuan",
          "requestor_name": "Tuan Nguyen"
        },
        "closure_reason": null,
        "cancel_reason": null,
        "new_asset": {
          "id": "bd1e6758db333850f5d33892399619c9",
          "serial_number": "R90RV8RZ",
          "model": "X1 Yoga 3rd Gen",
          "model_type": "Executive"
        }
      }
    },
    "approver": {
      "id": "3793f73197030d105026b1e3f153af9b",
      "userName": "tuanvoanh.nguyen@dxc.com",
      "name": "Tuan Nguyen",
      "email": "tuanvoanh.nguyen@dxc.com",
      "title": "",
      "delegate": false
    },
    "approvalBy": {
      "id": "3793f73197030d105026b1e3f153af9b",
      "userName": "tuanvoanh.nguyen@dxc.com",
      "name": "Tuan Nguyen",
      "email": "tuanvoanh.nguyen@dxc.com",
      "title": ""
    }
  },
  KBPcCost: '',
  onApprovalClick: () => {},
  onRejectClick: () => {},
  locale: {
    requestorName: 'Requestor Name',
    requestorEmail: 'Requestor Email',
    recipientName: 'Recipient Name',
    recipientEmail: 'Recipient Email',
    workerType: 'Worker Type',
    reason_for_approval: 'Reason For Approval',
    costCenter: 'Cost Center',
    cost_knowledge_article: 'Cost Knowledge Article',
    clickHere: 'Click here',
    approverInfo: "Approver's Information",
    managerInfo: "Manager's Information",
    delegatedApproverInfo: "Delegated approver's information",
    approvedBy: "Approved By",
    rejectedBy: "Rejected By",
    business_justification_comments: 'Business Justification Comments',
    na: 'N/A',
    subTitle:{
      state: "State",
      status: "Status",
      created: "Created",
      ticketNumber: "Number",
      priority: "Priority",
      stage: "Stage",
      requested: "Requested",
      incident: "Incident",
      request: "Request",
      requestNumber: "Request Number",
      btnApproval: "Approval",
      btnReject: "Reject"
    },
    commonStatus: {
      "Open": "Open",
      "open": "Open",
      "Reopen": "Reopen",
      "Closed": "Closed",
      "Resolved": "Resolved",
      "submitted": "Submitted",
      "cancelled": "Cancelled",
      "Cancelled": "Cancelled",
      "In Progress": "In Progress",
      "requested": "Requested",
      "Requested": "Requested",
      "Awaiting Approval": "AWAITING APPROVAL",
      "Rejected": "REJECTED",
      "No Longer Required": "NO LONGER REQUIRED",
      "Preparing Device": "PREPARING DEVICE",
      "Action Required": "Action Required",
      "Approved": "Approved",
      "Device in Transit":"Device in Transit",
      "Approval Rejected": "APPROVAL REJECTED",
      "Under Investigation": "UNDER INVESTIGATION",
      "Pending Cancellation": "PENDING CANCELLATION",
    }
  },
};

export default ApprovalDetail;